import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Clock, Moon, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen w-full bg-navy-800 overflow-hidden flex items-center pt-8 pb-20 px-4 md:px-8" data-id="element-176">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-navy-700 via-navy-800 to-navy-900 opacity-80" data-id="element-177" />

      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-178">
        <div className="absolute top-10 left-10 w-64 h-64 bg-gold-500/5 rounded-full blur-3xl" data-id="element-179" />
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-cream-100/5 rounded-full blur-3xl" data-id="element-180" />
      </div>

      <div className="relative max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-181">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="text-left z-10" data-id="element-182">
          <p className="text-gold-400 uppercase tracking-widest text-sm font-bold mb-4" data-id="element-183">
            Para mujeres mexicanas de 45 o más que se acuestan agotadas pero no
            pueden dormir
          </p>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-cream-100 leading-tight mb-6" data-id="element-184">
            Duerme Profundo Esta Noche y Con Ingredientes de Oxxo
          </h1>

          <p className="text-lg md:text-xl text-cream-200 font-body mb-8 leading-relaxed max-w-2xl" data-id="element-185">
            La guía con 7 templates listos que miles de mujeres mexicanas ya
            usan para dormir toda la noche y despertar con energía real y callar
            la mente ansiosa de las 3AM.
          </p>

          <div className="mb-8" data-id="element-186">
            <Button className="w-full md:w-auto text-xl px-10 py-5" onClick={() => {
            document.getElementById('precio')?.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }} data-id="element-187">
              SÍ, QUIERO DORMIR ESTA NOCHE
            </Button>
          </div>

          {/* Benefits Grid */}

          <div className="flex flex-col items-start gap-3" data-id="element-188">
            <p className="text-cream-200/70 text-sm pl-2" data-id="element-189">
              Acceso inmediato. Descarga en segundos.
            </p>
          </div>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative z-10 flex justify-center lg:justify-end" data-id="element-190">
          <div className="relative w-full max-w-md lg:max-w-lg" data-id="element-191">
            <div className="absolute inset-0 bg-gold-500/20 rounded-3xl transform rotate-6 blur-lg" data-id="element-192" />
            <img src="https://cdn.magicpatterns.com/uploads/nToBRFGC3aspAh2ByoqExN/heylloyd-image-1771988789436.jpg" alt="Sueño Profundo Hormonal Guía Digital" className="relative rounded-2xl shadow-2xl border-4 border-navy-700/50 w-full object-cover transform -rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-193" />

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-cream-100 p-4 rounded-xl shadow-xl border border-gold-500/30 max-w-[200px]" data-id="element-194">
              <div className="flex items-center gap-1 mb-1" data-id="element-195">
                <Star className="h-4 w-4 text-gold-500 fill-current" data-id="element-196" />
                <Star className="h-4 w-4 text-gold-500 fill-current" data-id="element-197" />
                <Star className="h-4 w-4 text-gold-500 fill-current" data-id="element-198" />
                <Star className="h-4 w-4 text-gold-500 fill-current" data-id="element-199" />
                <Star className="h-4 w-4 text-gold-500 fill-current" data-id="element-200" />
              </div>
              <p className="text-navy-900 text-xs font-bold" data-id="element-201">
                "Dormí 7 horas seguidas por primera vez en dos años."
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}